"use strict";

class SuperCmsController {

    constructor($scope, SSHttpService, SSUtilService, SSDateService, SSAwsService, SSAppService, SSAlertService, SSUserService) {
        const self = this;

        self.$scope = $scope;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAwsService = SSAwsService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;
        self.category = self.data.category;

        self.CMS_CATEGORY_JOBS = SHOWSUITE.CMS_CATEGORY_JOBS;
        self.CMS_CATEGORY_PRESS = SHOWSUITE.CMS_CATEGORY_PRESS;
        self.CMS_CATEGORY_SEARCH_GROUPS = SHOWSUITE.CMS_CATEGORY_SEARCH_GROUPS;
        self.CMS_CATEGORY_FEATURED = SHOWSUITE.CATEGORY_FEATURED;
        self.CMS_CATEGORY_WATCH = SHOWSUITE.CATEGORY_WATCH;
        self.CMS_CATEGORY_MARKETING_FEATURES = SHOWSUITE.CMS_CATEGORY_MARKETING_FEATURES;

        self.CMS_CATEGORIES_MAP = {};
        self.CMS_CATEGORIES_MAP[self.CMS_CATEGORY_JOBS] = 'Jobs';
        self.CMS_CATEGORIES_MAP[self.CMS_CATEGORY_PRESS] = 'Press';
        self.CMS_CATEGORIES_MAP[self.CMS_CATEGORY_SEARCH_GROUPS] = 'Search Groups';
        self.CMS_CATEGORIES_MAP[self.CMS_CATEGORY_FEATURED] = 'Featured';
        self.CMS_CATEGORIES_MAP[self.CMS_CATEGORY_WATCH] = 'Watch';
        self.CMS_CATEGORIES_MAP[self.CMS_CATEGORY_MARKETING_FEATURES] = 'Marketing Features';

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        let self = this;

        self.cms = null;

        self.cmsCats = '';
        self.cmsId = '';

        self.cmsLoadingIndicator = false;
        self.updateCmsContainerVar = false;
        self.showAllowedTags = false;

        self.errorMessage = null;

        self.errTitle = '';
        self.errContent = '';
        self.errCatId = '';

        self.getData();
    }

    getData() {
        let self = this;

        let url = 'sec/super/cms/' + self.category + '/get';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.clear();

            self.cms = response.data.cms;
        });
    }

    toggleEditContainer() {
        const self = this;

        self.cmsDetailsModal = !self.cmsDetailsModal;
        jQuery('#cmsDetailsModal').modal(self.cmsDetailsModal ? 'show' : 'hide');
    }

    open(entry) {
        const self = this;

        if (!entry) {
            self.entry = {
                category_id: self.category
            };
        } else {
            self.entry = angular.copy(entry);
        }

        self.errorMessage = null;

        self.errTitle = '';
        self.errContent = '';
        self.errCatId = '';

        if(!self.entry.file_name)
        self.entry.file_name = self.entry.file_uri;

        self.toggleEditContainer();
    }

    post() {
        const self = this;

        if (!self.validate()) return;

        if(self.entry.file_name == '')
            self.entry.file_name = self.entry.file_uri;
        if(self.entry.file_uri == '')
            self.entry.file_name = NULL;


        self.errorMessage = null;
        let url = 'sec/super/cms/' + self.category + '/post';

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.entry).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Saved successfully.');

            let entry = response.data.cms;

            if (!self.entry.id) {
                self.cms.push(entry);
            } else {
                jQuery.each(self.cms, function (i, e) {
                    if (e.id == entry.id) {
                        angular.merge(e, entry);
                        return false;
                    }
                });
            }

            self.toggleEditContainer();
        });
    }

    validate() {
        const self = this;

        let error = false;

        self.errTitle = '';
        self.errContent = '';

        if (!self.entry.title) {
            self.errTitle = 'CMS title is required';
            error = true;
        }
        if (!self.entry.content) {
            self.errContent = 'CMS content is required';
            error = true;
        }

        return !error;
    }

    remove(entry) {
        const self = this;

        if (confirm('Are you sure you want to delete it?')) {

            let url = 'sec/super/cms/' + self.category + '/delete';
            let params = {
                id: entry.id
            };

            loading(true);
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                jQuery.each(self.cms, function (i, e) {
                    if (e.id == entry.id) {
                        self.cms.splice(i, 1);
                        return false;
                    }
                });

                self.SSAlertService.success('Removed successfully.');
            });
        }
    }

    showAllowedTag() {
        const self = this;

        self.showAllowedTags = (self.showAllowedTags == false) ? true : false;
    }

    upload(file) {
        const self = this;

        let url = 'sec/super/cms/' + self.category + '/s3-policy-document';
        self.SSAwsService.uploadAPIRequest(file, url, function (response) {
            self.entry.file_uri = response.config.data.key;
            self.entry.file_name = response.config.data.randomname +'.'+response.config.data.extension;
        });

    }

    getContentsPlaceholder() {
        const self = this;

        let placeholder = '';
        if ([self.CMS_CATEGORY_SEARCH_GROUPS, self.CMS_CATEGORY_FEATURED, self.CMS_CATEGORY_MARKETING_FEATURES].indexOf(self.category) != -1) {
            placeholder = 'URL';
        } else if ([self.CMS_CATEGORY_JOBS, self.CMS_CATEGORY_PRESS].indexOf(self.category) != -1) {
            placeholder = 'Contents';
        }

        return placeholder;
    }
}

SuperCmsController.$inject = ['$scope', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAwsService', 'SSAppService', 'SSAlertService', 'SSUserService'];
app.controller('SuperCmsController', SuperCmsController);

